import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('@/pages/home/page'));
const Game = lazy(() => import('@/pages/game/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Game />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;